import ComponentMap from "@components/page/component-map"

/* 08/22 the bodyClass prop is a holdover for older SASS styling,
where previously it was added to the body, we're now wrapping these pages.
This div should be removed once we remove SASS */

const Page = ({ content, bodyClass }) => {
  const { data, locale } = content
  const post = data.page

  return (
    <div className={bodyClass}>
      <div className="page__content">
        {post.content &&
          post.content.map((content, index) => {
            var Cname = content.template ? ComponentMap[content.template] : ComponentMap[content.__typename]
            if (Cname === undefined) {
              return (
                <h1 key={index} style={{ color: "red" }}>
                  Template missing for {content.template}
                </h1>
              )
            }
            return <Cname key={`${Cname}-index`} locale={locale} content={content} index={index} />
          })}
      </div>
    </div>
  )
}

export default Page
